import { render, staticRenderFns } from "./autoComplete.vue?vue&type=template&id=135fa1a4"
import script from "./autoComplete.vue?vue&type=script&lang=js"
export * from "./autoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports